import React, { Component, Fragment} from 'react';

import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import './Register.Module.scss';

import Top from 'components/UI/Top/Top';
import FilterMenu from 'components/UI/FilterMenu/FilterMenu';

/**
 * import components
 */

import registerUser from 'actions/authentication/register';

const mapDispatchToProps = {
    registerUser
};

class Register extends Component {

    constructor() {
        super();

        this.state = {
            email: '',
            password: '',
            agreed: false
        }

        this.handleFieldChange  = this.handleFieldChange.bind(this);
        this.handleRegistration        = this.handleRegistration.bind(this);
        this.handlePrivacyChange        = this.handlePrivacyChange.bind(this);
    }

    handleFieldChange(event) {

        let array = [];
        array[event.target.name] = event.target.value
        
        this.setState(array);
    }

    handlePrivacyChange(event) {
        this.setState({agreed: event.target.checked});
    }

    handleRegistration() {

        if(!this.state.agreed) {
            return alert('U moet akkoord gaan met het privacybeleid om te kunnen registreren');
        }

        this.props.registerUser(this.state).then(Result => {
            ReactGA.event({
                category: "Account created",
                action: "User created an accout",
            });
        });
    }

    render() {
        return (
            <Fragment>
                
                <Top></Top>
                <div styleName='pagewrapper'>
                    <FilterMenu display="false"></FilterMenu>
                    <div styleName='wrapper'>
                        <h1>REGISTREREN</h1>
                        <h3 style={{fontStyle: 'italic'}}>Maak een account aan </h3>
                        
                        <form styleName='form'>
                            <input styleName='input' value={this.state.email} onChange={this.handleFieldChange} name='email' type="text" placeholder="Email" />
                            <input styleName='input' value={this.state.name} onChange={this.handleFieldChange} name='name' type="name" placeholder="Naam" />
                            <input styleName='input' value={this.state.password} onChange={this.handleFieldChange} name='password' type="password" placeholder="Wachtwoord" />
                            <input styleName='input' value={this.state.password_confirmation} onChange={this.handleFieldChange} name='password_confirmation' type="password" placeholder="Wachtwoord check" />

                            <label htmlFor="privacy">Ik ga akkoord met het <a href="/Privacybeleid.pdf" target="_blank">privacybeleid:</a></label>
                            <input onChange={this.handlePrivacyChange} checked={this.state.agreed} type="checkbox" id="privacy"></input>

                            <p>We gebruiken je gegevens alleen om je favoriete lessen op te slaan en je op de hoogte te houden van de website. Wil je meer weten over de nieuwste ontwikkelingen? <a href="https://mu.nl/nl/newsletter" styleName="link" target="_blank">Schrijf je dan in</a> voor de MU of De Creatieve Code nieuwsbrief.</p>
                            

                            <div styleName='button-wrapper'>
                                <a href="#" onClick={this.handleRegistration} styleName="submit" >Registreren</a>
                            </div>
                        </form>
                        
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(null, mapDispatchToProps)(Register);
